import {Component, ViewChild} from '@angular/core';

import {AeFDonneesSaisieStatutFacturesAchat, AeFMettreAJourStatutFacturesAchatParametres, EFactTraitementService} from '../../../../../../val-ammon-services/val-services-efact-lib/src/public-api';
import {BoiteDialogueLogComponent} from '../../../../../../val-ammon-composants/val-traitements-lib/src/public-api';
import {SelectionStatutFactureAchatEditionComponent} from '../selection-statut-facture-achat-edition/selection-statut-facture-achat-edition.component';
import {ValApiResultat} from '../../../../../../val-ammon-services/val-services-communs-lib/src/public-api';

//Traitement de mise à jour du satut des factures d’achat
@Component (
{
  selector: 'val-mettre-a-jour-statut-factures-achat',
  imports: 
  [
    SelectionStatutFactureAchatEditionComponent,
    BoiteDialogueLogComponent
  ],
  templateUrl: './mettre-a-jour-statut-factures-achat.component.html',
  styleUrl: './mettre-a-jour-statut-factures-achat.component.scss',
})
export class MettreAJourStatutFacturesAchatComponent 
{
  //Création
  //  Paramètres
  //    eFactTraitementService: Service e-Facture
  constructor (private eFactTraitementService: EFactTraitementService) 
  {
  }
  
  //Boîte de dialogue log
  @ViewChild ("boiteDialogueLog")
  public boiteDialogueLog!: BoiteDialogueLogComponent;

  //Boîte de dialogue de sélection du statut
  @ViewChild ("selectionStatut")
  public selectionStatut!: SelectionStatutFactureAchatEditionComponent;

  //Exécute le traitement
  //  Paramètres
  //    identifiantsFactures : Identifiants des factures
  public async Executer (identifiantsFactures: string[]) : Promise<void> 
  {
    let operation: Promise<void>;
    let valApiResultat: ValApiResultat<AeFDonneesSaisieStatutFacturesAchat>;
    let aefMettreAJourStatutFacturesAchatParametres: AeFMettreAJourStatutFacturesAchatParametres;

    operation = new Promise<void> (async (fonctionRetour) =>
    {
      try
      {
        valApiResultat = await this.eFactTraitementService.RetournerDonneesSaisieStatutFactureAchat ();

        if (valApiResultat.status === "success")
        {
          this.selectionStatut.statuts = valApiResultat.resultat!.statuts;

          await this.selectionStatut.Ouvrir ();

          if (this.selectionStatut.donnees.valide)
          {
            aefMettreAJourStatutFacturesAchatParametres = new AeFMettreAJourStatutFacturesAchatParametres ();
            aefMettreAJourStatutFacturesAchatParametres.identifiantSession = crypto.randomUUID ();
            aefMettreAJourStatutFacturesAchatParametres.identifiantsFactures = identifiantsFactures;
            aefMettreAJourStatutFacturesAchatParametres.identifiantStatutTransmis = this.selectionStatut.donnees.identifiantStatut;
            aefMettreAJourStatutFacturesAchatParametres.codeStatut = this.selectionStatut.donnees.codeStatut;
            aefMettreAJourStatutFacturesAchatParametres.codeMotif = this.selectionStatut.donnees.codeMotif;
            aefMettreAJourStatutFacturesAchatParametres.note = this.selectionStatut.donnees.note.trim () === "" ? null : this.selectionStatut.donnees.note;

            this.boiteDialogueLog.Executer (aefMettreAJourStatutFacturesAchatParametres.identifiantSession);

            await this.eFactTraitementService.MettreAJourStatutFacturesAchat (aefMettreAJourStatutFacturesAchatParametres);

            await this.boiteDialogueLog.AttendreFermeture ();
          }
        }
      }
      catch (erreur)
      {
      }

      fonctionRetour ();
    });

    return operation;
  }
}
